import { Link } from 'react-router-dom';
import { articles, getArticle } from '@/mocks/articles';
import { getChannel } from '@/mocks/channels';
import { formatCount } from '@/components/feature/ArticleCard';

export default function SidePanel({ current }: { current: number }) {
  const currentArticle = getArticle(current);
  const channel = currentArticle ? getChannel(currentArticle.channel) : undefined;
  const channelArticles = currentArticle
    ? articles.filter((a) => a.channel === currentArticle.channel && a.id !== current)
    : [];
  const channelHits = [...channelArticles].sort((a, b) => b.views - a.views).slice(0, 5);
  const globalHits = [...articles]
    .filter((a) => a.id !== current)
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  const list = channelHits.length >= 2 ? channelHits : globalHits;

  return (
    <aside className="space-y-6">
      {/* 热读排行 */}
      <section className="rounded-lg border border-background-200/70 bg-background-50">
        <div className="flex items-center gap-2 border-b border-background-200/70 px-4 py-3.5">
          <i className="ri-fire-line text-primary-500" aria-hidden="true" />
          <h2 className="text-base font-bold text-foreground-950">
            {channelHits.length >= 2 ? '本栏目热读' : '全网热读'}
          </h2>
        </div>
        <ol className="p-2">
          {list.map((a, i) => (
            <li key={a.id}>
              <Link
                to={`/news/${a.id}`}
                className="group flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
              >
                <span
                  className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    i < 3 ? 'bg-primary-600 text-background-50' : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {i + 1}
                </span>
                <span className="line-clamp-2 flex-1 text-sm font-medium text-foreground-700 group-hover:text-primary-700">
                  {a.title}
                </span>
                <span className="shrink-0 text-xs text-foreground-400">{formatCount(a.views)}</span>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      {/* 栏目入口 */}
      {currentArticle && channel && (
        <section className="rounded-lg bg-gradient-to-br from-primary-700 to-primary-600 p-5 text-primary-100">
          <span className="inline-flex items-center gap-1 rounded-full bg-background-50/20 px-2.5 py-1 text-xs font-medium text-background-50">
            <i className="ri-fire-fill" aria-hidden="true" /> {channel.name}
          </span>
          <p className="mt-3 text-lg font-bold text-background-50">去“{channel.name}”栏目继续吃瓜</p>
          <p className="mt-1 text-xs leading-relaxed text-primary-100/80">{channel.tagline}，还有更多新鲜瓜等你。</p>
          <Link
            to={`/channel/${currentArticle.channel}`}
            className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
          >
            进入栏目 <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </section>
      )}
    </aside>
  );
}